import { Button, Container, Stack, Typography, Box } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import ApplicationView from '../Global/ApplicationView';
import { getOfflineApplicationRes } from '../../store/Slice/Lead/LeadSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';
import { NOT_AVAILABLE } from '../Global/Constants';

function ProcessLogin() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { leadesItem } = location?.state || {};

  const { LoginData } = useLoginSelector();
  const { AppData } = useLeadSelector();
  const myData = structuredClone(AppData || {});

  const getApplicationByIdApi = useCallback(() => {
    const credential = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      applicationId: leadesItem?.[0]?.applicationId
    };
    dispatch(getOfflineApplicationRes(credential));
  }, [LoginData, leadesItem, dispatch]);

  useEffect(() => {
    getApplicationByIdApi();
  }, [getApplicationByIdApi]);

  const currentStatus = leadesItem?.[0]?.logInStatusName || NOT_AVAILABLE;

  return (
    <Page title="Partner Management System || Process Login">
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', pb: 8, pt: 2.5 }}>
        <Container maxWidth="xl">
          {/* Top Header Row */}
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems={{ xs: 'flex-start', md: 'center' }}
            justifyContent="space-between"
            sx={{ mb: 3.5, gap: 2 }}
          >
            {/* Left: Back Button & Title */}
            <Stack direction="row" spacing={2.5} alignItems="center">
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
                onClick={() => navigate('/login')}
                sx={{
                  color: '#0284c7',
                  borderColor: '#bae6fd',
                  bgcolor: '#ffffff',
                  borderRadius: '10px',
                  fontWeight: 600,
                  fontSize: '13px',
                  textTransform: 'none',
                  py: 0.9,
                  px: 2,
                  boxShadow: '0 2px 6px rgba(2, 132, 199, 0.06)',
                  '&:hover': {
                    bgcolor: '#f0f9ff',
                    borderColor: '#0284c7'
                  }
                }}
              >
                Back to Login List
              </Button>

              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 800,
                    color: '#0f172a',
                    fontSize: { xs: '20px', sm: '24px' },
                    letterSpacing: '-0.3px',
                    lineHeight: 1.2
                  }}
                >
                  Process Application
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', fontSize: '13px', mt: 0.25 }}>
                  Review application details, applicant profile, loan requirement, and process bank
                  submission.
                </Typography>
              </Box>
            </Stack>

            {/* Right: Breadcrumbs & Current Status */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Box>
                <BrudCrumbs />
              </Box>

              <Stack direction="row" spacing={1} alignItems="center">
                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#0f172a' }}>
                  Current Status:
                </Typography>
                <Box
                  sx={{
                    bgcolor: '#fef3c7',
                    color: '#b45309',
                    px: 1.75,
                    py: 0.4,
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 700,
                    letterSpacing: '0.2px',
                    border: '1px solid #fde68a'
                  }}
                >
                  {currentStatus}
                </Box>
              </Stack>
            </Stack>
          </Stack>

          <ApplicationView parent="login" offlineResponse={myData} />
        </Container>
      </Box>
    </Page>
  );
}

export default ProcessLogin;
